/**
 * Dark Mode Handler
 * Applies the theme mode set by the Shopify admin in theme settings
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get the theme mode from the HTML data attribute
  const html = document.documentElement;
  const themeMode = html.getAttribute('data-theme') || 'light';
  
  // Apply the theme immediately
  applyTheme(themeMode);
  
  // Add smooth transitions after initial load to prevent flash
  setTimeout(function() {
    document.body.classList.add('theme-transitions-enabled');
  }, 100);
});

/**
 * Apply the specified theme
 * @param {string} theme - 'light' or 'dark'
 */
function applyTheme(theme) {
  const html = document.documentElement;
  const body = document.body;
  
  // Remove existing theme classes
  body.classList.remove('theme-light', 'theme-dark');
  
  // Apply new theme
  html.setAttribute('data-theme', theme);
  body.classList.add('theme-' + theme);
  
  // Dispatch custom event for other scripts that might need to know
  window.dispatchEvent(new CustomEvent('themeApplied', {
    detail: { theme: theme }
  }));
} 